'use client'

import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'

interface NewIconProps {
  articleOpenDate: string
}

export default function NewIcon({ articleOpenDate }: NewIconProps) {
  const [isNew, setIsNew] = useState(false)

  useEffect(() => {
    const current = new Date()
    const open = new Date(articleOpenDate)
    const diffTime = Math.abs(current.getTime() - open.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    setIsNew(diffDays < 7)
  }, [articleOpenDate])

  if (!isNew) {
    return null
  }

  return <p className={styles.iconNew}>NEW</p>
}
